import { render, staticRenderFns } from "./DragHandle.vue?vue&type=template&id=6543c122"
import script from "./DragHandle.vue?vue&type=script&lang=js"
export * from "./DragHandle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports